import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React, {useEffect, useRef, useState} from 'react';
import { CardComponent } from '../../../util/CardComponent';
import { useAppSelector } from '../hooks';
import { setCommentTrendChartOptions } from '../utils';
import { selectCommentTrend } from './commentTrendSlice';
require('highcharts/modules/exporting')(Highcharts);

export function CommentTrendComponent() {
  const trendState = useAppSelector(selectCommentTrend);
  const { dataPoints, isLoading } = trendState;
  const { title, categories } = trendState.apiResponse;
  const { chartSubtitle } = trendState;
  const chartRef = useRef();
  const ChartHeightPixels = 300;
  const [cardTitle, setCardTitle] = useState(
    'Sentiment Trend (# coded)'
  );

  useEffect(() => {
    setCardTitle(isLoading ? 'Sentiment Trend (# coded)' : '');
  }, [isLoading]);

  return (
    <CardComponent title={cardTitle} isLoading={isLoading}>
      <section className="highcharts-component">
        {dataPoints.length > 0 && (
          <HighchartsReact
            highcharts={Highcharts}
            options={setCommentTrendChartOptions(
              ChartHeightPixels,
              title,
              chartSubtitle,
              categories,
              dataPoints
            )}
            allowChartUpdate={true}
            ref={chartRef}
          />
        )}
      </section>
    </CardComponent>
  );
}
